import { createContext, useContext, useReducer } from 'react';
import { ACTION_TYPES, ProfileReducer, ProfileState } from './profile-reducer';


const ProfileContext = createContext<ProfileState | undefined>(undefined);
const ProfileContextDispatchContext = createContext({} as any);

const ProfileProvider = ({ children }: { children: React.ReactNode }) => {
    const [state, dispatch] = useReducer(ProfileReducer, {  } as ProfileState);

    return (
        <ProfileContext.Provider value={state}>
            <ProfileContextDispatchContext.Provider value={dispatch}>
                {children}
            </ProfileContextDispatchContext.Provider>
        </ProfileContext.Provider>
    );
}

const useProfileState = () => {
    const context = useContext(ProfileContext);
    if (context === undefined) {
        throw new Error('useHomeState must be used within a HomeProvider');
    }
    return context;
}

const useProfileDispatch = () => {
    const context = useContext(ProfileContextDispatchContext);
    if (context === undefined) {
        throw new Error('useHomeDispatch must be used within a HomeProvider');
    }
    return context;
}

export { ProfileProvider, useProfileDispatch, useProfileState, ACTION_TYPES };
